import React, { useState } from "react";

import ImageSrc from "../../../assets/product.jpg";
import PlusSrc from "../../../assets/plus.png";

import styled from "styled-components";

const Container = styled.div`
  width: 47.7%;
  height: 125px;
  background: #f5f5f5;
  margin: 0 2% 2% 0;
  border-radius: 5px;
  border: 1px solid #eee;
  cursor: pointer;
  &:hover {
    background: #f5f5f5;
  }
`;
const ImageContainer = styled.div`
  width: 28%;
  height: 90%;
  background: white;
  float: left;
  margin: 1.1%;
  text-align: center;
`;
const Image = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 5px;
`;
const PlusImg = styled.img`
  width: 22px;
  height: 22px;
`;
const DetailsContainer = styled.div`
  width: 68%;
  height: 100%;
  float: right;
`;
const Details = styled.div`
  width: 80%;
  height: 100%;
  float: left;
`;
const Name = styled.h3`
  font-size: 1em;
  margin: 0;
  padding: 4% 0 1% 0;
  font-weight: 500;
`;
const Measurement = styled.p`
  margin: 0;
  padding: 0 0 5% 0;
  color: gray;
`;
const Price = styled.button`
  margin: 0;
  padding: 5px 10px;
  color: black;
  border: none;
  border-radius: 5px;
  background: white;
  font-size: 1em;
`;
const Actions = styled.div`
  width: 20%;
  height: 100%;
  float: right;
  text-align: center;
`;
const EditButton = styled.button`
  display: block;
  margin: 62% 0 5% 20%;
  background: white;
  padding: 6px 8px;
  border-radius: 5px;
  outline: none;
  cursor: pointer;
  background: white;
  border: none;
  background: none;
`;
const Input = styled.input`
  width: 100px;
  background: none;
  border: none;
  padding: 5px;
  font-size: 1em;
  outline: none;
`;

// const ButtonImage = styled.img`
//    width: 14px;
//    height: 14px;
// `
function Product(props) {
  const [price, setPrice] = useState(props.product.price);

  const input = {
    productId: props.product._id,
    price,
    shopId: localStorage.shopId,
    name: props.product.name,
    categoryId: props.product.subCategoryId,
    categoryName: props.product.subCategoryName,
    brandId: props.product.brandId,
    brandName: props.product.brandName,
  };
  return (
    <Container>
      <ImageContainer>
        <Image src={props.product.images[0]} alt="product name" />
      </ImageContainer>
      <DetailsContainer>
        <Details>
          <Name>{props.product.name}</Name>
          <Measurement>{props.product.measurment}</Measurement>
          <Price>
            <Input
              placeholder="Price"
              min="0"
              type="number"
              onChange={(e) => setPrice(e.target.value)}
              value={price}
            />{" "}
            TK
          </Price>
        </Details>
        <Actions>
          <EditButton onClick={() => props.addHandler(input)}>
            <PlusImg src={PlusSrc} alt="Plus" />
          </EditButton>
        </Actions>
      </DetailsContainer>
    </Container>
  );
}

export default Product;
